import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const AttrZeit = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  let position = Math.abs(parseInt(value.value)) + "%";
  position = 1015
  position = 0

  console.log("AttrZeit: ", props.style.properties);
  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        backgroundColor: "green",
        opacity: 0.5,
        visibility: props.props.visibility,
        left: `calc(${props.style.left} + ${position * globalVars.scaleFactor}px)`,
        width: props.style.properties.elementWidth,
        height: props.style.properties.elementHeight,
      }}
      title={language.displayText(value.name)}
    >
    </div>
  );
});

export default AttrZeit;


/*



    {
      "type": "AttrZeit",
      "left": "0px",
      "top": "0px",
      "width": "1045px",
      "height": "106px",
      "backgroundColor": "darkgrey",
      "activeColor": "green",
      "borderStyle": "solid",
      "borderWidth": "1px",
      "borderColor": "black",
      "variable": "struct.bPr1",
      "varIsReference": true,
      "properties":{
        "elementWidth": "36px"
      }
    }

*/